import type { Navigation } from '@toolpad/core/AppProvider';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { colors } from 'styles/colors';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CategoryIcon from '@mui/icons-material/Category';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ProductsIcon from 'icons/ProductsIcon';
import CategoriesIcon from 'icons/CategoryIcon';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import BoltIcon from '@mui/icons-material/Bolt';

export const NAVIGATION: Navigation = [
  {
    segment: 'users',
    title: 'Users',
    icon: <PeopleAltIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        segment: 'all-users',
        title: 'All Users',
      },
      {
        segment: 'flagged',
        title: 'Flagged',
      },
      {
        segment: 'devices',
        title: 'Devices',
      },
    ],
  },
  {
    segment: 'teams',
    title: 'Teams',
    icon: <Diversity3Icon sx={{ fontSize: 20 }} />,
    children: [
      {
        segment: 'team-invitation-requests',
        title: 'Requests',
      },
    ],
  },
  {
    segment: 'products',
    title: 'Products',
    icon: <ProductsIcon size={20} color='inherit' />,
    children: [
      {
        segment: 'all-products',
        title: 'Products',
      },
      {
        segment: 'suggestions',
        title: 'Suggestions',
      },
      {
        segment: 'deleted-suggestions',
        title: 'Deleted Suggestions',
      },
      {
        segment: 'search',
        title: 'Search Test',
      },
      {
        segment: 'agent-search',
        title: 'Agent Search',
      },
      {
        segment: 'talia',
        title: 'Talia',
      },
    ],
  },
  {
    segment: 'categories',
    title: 'Categories',
    icon: <CategoriesIcon size={20} color='inherit' />,
    children: [
      {
        segment: 'all-categories',
        title: 'All Categories',
      },
    ],
  },
  {
    segment: 'raw-products',
    title: 'Raw Products',
    icon: <ProductsIcon size={20} color='inherit' />,
    children: [
      {
        segment: 'categories',
        title: 'Categories',
      },
      {
        segment: 'review',
        title: 'Review',
      },
    ],
  },
  {
    segment: 'open-facts',
    title: 'Open Facts',
    icon: <ProductsIcon size={20} color='inherit' />,
    children: [
      {
        segment: 'beauty',
        title: 'Beauty',
      },
    ],
  },
  {
    segment: 'stores',
    title: 'Stores',
    icon: <StorefrontIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        segment: 'all-stores',
        title: 'All Stores',
      },
      {
        segment: 'store-orders',
        title: 'Store Orders',
      },
    ],
  },
  {
    segment: 'orders',
    title: 'Orders',
    icon: <LocalShippingIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        segment: 'all-orders',
        title: 'All Orders',
      },
    ],
  },
  {
    segment: 'reports',
    title: 'Reports',
    icon: <FlagOutlinedIcon sx={{ fontSize: 20 }} />,
    children: [
      {
        segment: 'content',
        title: 'Content',
      },
    ],
  },
  {
    segment: 'actions',
    title: 'Actions',
    icon: <BoltIcon sx={{ fontSize: 20 }} />,
  },
  {
    segment: 'verification-codes',
    title: 'Verification codes',
    icon: <VerifiedUserIcon sx={{ fontSize: 20 }} />,
  },
  {
    segment: 'whatsapp',
    title: 'Whatsapp',
    icon: <WhatsAppIcon sx={{ fontSize: 20 }} />,
  },
];
